export default "__VITE_ASSET__BhF5dBaa__";